module.exports = __webpack_public_path__ + "img/buessiness_hy_h1.d0751ee9.png";